import { render } from "./ak.vue?vue&type=template&id=33e4ab5e&scoped=true"
const script = {}

import "./ak.vue?vue&type=style&index=0&id=33e4ab5e&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e4ab5e"]])

export default __exports__